<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>公告</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <router-link
        class="btn mybtnstyle btn-dark white_textcolor"
        :to="{ path: '/serviceMain/boardEditor' }"
      >
        新增公告
      </router-link>
      <!-- <button type="button" class="btn mybtnstyle btn-dark white_textcolor">
        <a href="#/main/boardEditor"></a>新增公告</button> -->
    </div>
    <div class="row">
      <table
        class="table table-striped jambo_table bulk_action table-font-size"
      >
        <thead>
          <tr class="headings">
            <th class="column-title column-width-subject">主旨</th>
            <th class="column-title column-width-employ">公告人</th>
            <th class="column-title column-width-date">起始日～到期日</th>
            <th class="column-title no-link last column-width-inspect">
              <span class="nobr">檢視</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in list">
            <tr class="headings">
              <th class="subject-simply">{{ item.subject }}</th>
              <th>{{ item.announcer }}</th>
              <th>{{ item.startAt }} ~ {{ item.endAt }}</th>
              <th>
                <router-link
                  class="red_textcolor"
                  :to="{ name: 'BoardDetail', params: { id: item.id } }"
                >
                  檢視
                </router-link>
              </th>
            </tr>
          </template>
        </tbody>
      </table>
      <!-- <div class="pull-right">
      <ul class="pagination">
        <li v-bind:class="{disabled: page == 1}">
          <a href="javascript:;" @click="clickNewPage(1)" v-bind:class="{active: page == 1}">第一頁</a>
        </li>
        <li>
          <a href="javascript:;" @click="clickNewPage(pages_show_list[0]-1)" v-show="page-2>1&&pages_show_list[0]-1!=1"> ... </a>
        </li>
        <li v-for="n in pages_show_list" v-bind:class="{active: n == page}" @click="clickNewPage(n)">
          <a href="javascript:;" ng-bind="n">{{n}}</a>
        </li>
        <li>
          <a href="javascript:;" @click="clickNewPage(pages_show_list[4]+1)" v-show="page+2<totalPage&&pages_show_list[4]+1<totalPage"> ... </a>
        </li>
        <li v-show='totalPage>1' v-bind:class="{disabled: page == totalPage }">
          <a href="javascript:;" @click="clickNewPage(totalPage)" v-bind:class="{active: page == totalPage }">最後一頁</a>
        </li>
      </ul>
    </div> -->
    </div>
  </div>
</template>

<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import moment from 'moment'
import Updatekml from '../../assets/js/tool/updateKml.js'

import notification from '../../assets/js/tool/notificaiton.js'
export default {
  name: 'Board',
  data() {
    return {
      fullPage: false,
      loader: null,
      npp: 10,
      page: 1,
      list: [],
    }
  },
  methods: {
    showLoading() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      })
    },
  },
  mounted() {
    this.showLoading()
    notification.createNotification()
    API.get(`announcement/list`)
      .then((res) => {
        this.list = res.data.result
        this.list = this.list.sort(function (a, b) {
          return b.id - a.id //順序反轉
        })
        this.loader.hide()
      })
      .catch((err) => {
        this.loader.hide()
        console.error(err)
        // alert(err);
      })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4 {
  min-width: 140px;
}

input.inputstyle {
  min-width: 240px;
}
.column-width-subject {
  width: 40%;
}
.column-width-employ {
  width: 20%;
}
.column-width-date {
  width: 30%;
}
.column-width-inspect {
  width: 10%;
}
.subject-simply {
  overflow: hidden;
  text-overflow: ellipsis;
}
.mybtnstyle {
  margin-bottom: 20px;
}
.table-font-size {
  font-size: 14px;
}
.red_textcolor {
  font-style: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/announcement/Board.vue